import { useState } from 'react';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'automation-all-set-acknowledged';

/**
 * Hook to manage the "All Set" acknowledgment state
 * Tracks whether user has acknowledged the success state after connecting Instagram
 */
export const useAllSetAcknowledgment = () => {
    const [acknowledged, setAcknowledged] = useState(() => {
        return Cookies.get(COOKIE_NAME) === 'True';
    });

    const acknowledge = () => {
        Cookies.set(COOKIE_NAME, 'True', { expires: 365 });
        setAcknowledged(true);
    };

    return {
        acknowledged,
        acknowledge,
    };
};
